import { Box, Button, Stack, Typography } from "@mui/material";

import { useNavigate } from "../../../common";

import { MediumCustomIcon } from "../../layer00";

export const BoBrainActivityHeaderSection = () => {
  const navigate = useNavigate();

  return (
    <Box
      display="flex"
      flexDirection="row"
      alignItems="center"
      flexWrap="wrap"
      columnGap="1rem"
      rowGap=".75rem"
      bgcolor="#FFFFFF"
      borderBottom="1px solid #D9DEF4"
      sx={{
        position: "sticky",
        top: 0,
        zIndex: (theme) => theme.zIndex.appBar - 1,
        padding: {
          xs: "1rem",
          sm: "1rem 1rem 1rem 2rem",
        },
      }}
    >
      <Button
        variant="outlined"
        onClick={() => navigate("/user/boZone")}
        sx={{
          flexShrink: 0,
        }}
        startIcon={<MediumCustomIcon icon="ARROWLEFT" stroke="#425CC7" />}
      >
        Bo zone
      </Button>
      <Stack
        direction="column"
        flex={{
          xs: "1 1 100%",
          sm: "1 1 0",
        }}
        minWidth={0}
      >
        <Typography variant="cardSectionTitle" fontSize="1.25rem" noWrap>
          Inside Bo&rsquo;s brain
        </Typography>
        <Typography
          variant="cardSubtitle"
          fontSize=".8125rem"
          lineHeight="1rem"
          color="#53565A"
        >
          This is what Bo knows overall about you
        </Typography>
      </Stack>
    </Box>
  );
};
